<script setup>
import { computed } from "vue";
import { Icon } from "@iconify/vue";

import { useElements } from "../../../composables/elements";

const props = defineProps({
  websiteId: { type: Number, required: true },
  pageId: { type: Number, required: true },
  element: { type: Object, required: true },
});

const { updateElement } = useElements();

const isVisible = computed(() => props.element?.style?.additional?.visible !== "0");

const toggleVisibility = async () => {
  const updated = {
    ...props.element,
    pageId: props.pageId,
    style: {
      ...props.element.style,
      additional: {
        ...props.element.style?.additional,
        visible: isVisible.value ? "0" : "1",
      },
    },
  };
  await updateElement(updated);
};
</script>

<template>
  <div class="visibility-element">
    <div class="visibility-btn" @click="toggleVisibility">
      <Icon v-if="isVisible" icon="mdi:eye-outline" width="32" height="32" />
      <Icon v-else icon="mdi:eye-off-outline" width="32" height="32" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.visibility-element {
  background: #fff;
  padding: 6px;
  border-radius: 6px;
  border: 2px solid #000;
  cursor: pointer;
}
</style>
